export const acknowledgeCoBrandingBanner = () =>
  ({ type: 'ACKNOWLEDGE_CO_BRANDING_BANNER' } as const);
